<template>
  <div>
    <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary" dark v-bind="attrs" v-on="on"> Import new WIP</v-btn>
      </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Update WIP
        </v-card-title>

        <v-card-text>
          <p>Open the WIP list screen in WorkflowMax and copy and paste the whole screen into this text field.</p>
          <v-textarea label="WorkflowMax WIP" v-model="rawWip"/>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn href="https://app.workflowmax.com/organizations/9c483c99-b3b2-4625-bdb2-081145336d38/wip" target="_blank" color="primary">Open WorkflowMax WIP</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="processWip" color="primary">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <p>WIP Last Updated: {{ updated }}</p>
    <v-data-table dense :headers="headers" :items="wip" :items-per-page="1000">
      <template v-slot:item.time="{ item }">
        <div>{{ item.time|formatCurrency(2) }}</div>
      </template>
      <template v-slot:item.costs="{ item }">
        <div>{{ item.costs|formatCurrency(2) }}</div>
      </template>
      <template v-slot:item.deposits="{ item }">
        <div>{{ item.deposits|formatCurrency(2) }}</div>
      </template>
      <template v-slot:item.wip="{ item }">
        <div>{{ item.wip|formatCurrency(2) }}</div>
      </template>
      <template v-slot:item.estBillings="{ item }">
        <div>{{ item.estBillings|formatCurrency(2) }}</div>
      </template>

    </v-data-table>

  </div>
</template>

<script>

import {toLocalString} from "@/lib/dateTimeUtilities"

export default {
  name: "WIPSetup",
  permissions: ["Read Job"],
  components: {},
  computed: {},
  methods: {
    processWip() {
      // job rows are identified by their job id (e.g. "J02347 - Some Job Name"),
      // not by counting heading lines - the WFM WIP screen's heading/footer
      // text changes shape often and broke the old fixed-offset parsing.
      const jobLinePattern = /^(J0\d+)\s*-\s*(.*)$/
      const allLines = this.rawWip.split("\n").map(line => line.trim())

      // drop the pagination footer ("200 items per page", "Previous", "1", "Next", ...)
      // so it can't get swept into the last job's block as bogus trailing data
      const footerIndex = allLines.findIndex(line => /items per page$/i.test(line))
      const lines = footerIndex === -1 ? allLines : allLines.slice(0, footerIndex)

      const jobStarts = []
      lines.forEach((line, index) => {
        if (jobLinePattern.test(line)) {
          jobStarts.push(index)
        }
      })

      const rows = jobStarts.map((start, i) => {
        const end = jobStarts[i + 1] ?? lines.length
        const block = lines.slice(start, end).filter(line => line !== "")
        const [, jobId, job] = jobLinePattern.exec(block[0])

        return {
          jobId,
          job,
          client: block[1],
          time: parseFloat(block[2].replace(/,/g, "")),
          costs: parseFloat(block[3].replace(/,/g, "")),
          deposits: parseFloat(block[4].replace(/,/g, "")),
          wip: parseFloat(block[5].replace(/,/g, "")),
          // "Est. Billing" is an optional trailing column - present in some
          // WFM WIP exports (v2) but not others (v1).
          estBillings: block.length > 6 ? parseFloat(block[6].replace(/,/g, "")) : 0,
        }
      })

      this.wip = rows
      this.dialog = false
      this.save()
    },
    save() {
      this.$BwfApi.post("wip", this.wip).then(() => {
        this.$notify.toast("Saved")
        this.loadWip()
      })
    },
    loadWip() {
      this.$BwfApi.get("wip").then(response => {
        this.wip = response.data
        this.updated = (new Date(response.updated)).toString()
        for (const item of this.wip) {
          const job = this.findJob(item.jobId)
          if (job) {
            item.job = job.Name
            item.client = job.Client.Name
          } else {
            item.job = item.jobId
            item.client = ""
          }
        }
      })
    },
    loadJobs() {
      const endDate = new Date()
      const startDate = new Date()
      startDate.setFullYear(startDate.getFullYear() - this.$WfmApi.lookback)
      const start = toLocalString(startDate).substr(0, 10).replace(/-/g, "")
      const end = toLocalString(endDate).substr(0, 10).replace(/-/g, "")
      const query = {"from": start, "to": end, "detailed":true}

      this.$WfmApi.get("job.api/list", query).then(response => {
        this.jobs = this.$ensureArray(response.Jobs.Job)
        this.loadWip()
      })
    },
    findJob(JobId) {
      for (const job of this.jobs) {
        if (job.ID === JobId) {
          return job
        }
      }
      return false
    },
  },
  mounted() {
    this.loadJobs()
  },
  data() {
    return {
      dialog: false,
      jobs: [],
      rawWip: "",
      headers: [
        {text: "Client", value: "client"},
        {text: "Job Id", value: "jobId"},
        {text: "Job", value: "job"},
        {text: "Time", value: "time"},
        {text: "Costs", value: "costs"},
        {text: "Deposits", value: "deposits"},
        {text: "WIP", value: "wip"},
        {text: "Est Billings", value: "estBillings"},
      ],
      wip: [],
      updated: "",
      emptyRow: {
        client: "", jobId: "", job: "", time: 0, costs: 0, deposits: 0, wip: 0, estBillings: 0
      }
    }
  }
  ,
}

</script>


<style scoped>
.input {
  width: 100%;
}
</style>